var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAssistantLogoGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.2 31.7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 30.7c7.1-.5 12.8-6.1 13.3-13.2v-4.2C33.6 6.2 27.9.6 20.8.1c-2.4-.1-5-.1-7.4 0C6.2.6.5 6.2 0 13.3v4.2c.2 2.6 1.3 5 2.7 7 .8 1.4.3 3.2-.6 4.7-.6 1.1-.9 1.7-.7 2.1.2.4.8.4 1.9.4 2.1 0 3.6-.5 4.7-1.4.6-.5 1-.7 1.2-.7.2 0 .7.1 1.5.5.8.3 1.7.5 2.5.6 2.4.2 5 .2 7.4 0z",
    fill: "#aef600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 20.8l3.1-9.2c.2-.5.6-.8 1.1-.8s1 .3 1.1.8l3.1 9.2m5.3-10v10m-12-3.3h5.1",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })));
}
export default SvgAiAssistantLogoGreen;